import React, { useEffect, useState } from "react";
import {  Offcanvas } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form"; 

interface props {
    show: any
    handleClose: any
    // AIData: any
}
const RightAddEscalations = ({ show, handleClose }: props) => {
    const { control, setValue } = useForm();


    return (
        <Offcanvas show={show} onHide={handleClose} placement={"end"}  >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Add a request for Resolution</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>

                <div className="right-bar right-add-bar">
                    <div data-simplebar className="h-100"> 
                        <hr className="mt-0" />
                        <div className="filter-panel p-1">
                            <div className="form-group">
                                <input type="text" className="form-control" id="formrow-firstname-input" placeholder="Type Heading" />
                            </div>
                            <div className="form-group">
                                <textarea id="textarea" className="form-control" rows={5} placeholder="This textarea has a limit of 225 chars."></textarea>
                            </div>
                            <div className="mb-3">
                                <form action="#" className="dropzone">
                                    <div className="fallback">
                                        <input name="file" type="file" multiple />
                                    </div>
                                    <div className="dz-message needsclick">
                                        <div className="mb-3">
                                            <i className="display-4 text-muted bx bxs-cloud-upload"></i>
                                        </div>

                                        <h4>Drop files here or click to upload.</h4>
                                    </div>
                                </form>
                            </div>
                            <div className="form-group">
                                <select id="formrow-inputState" className="form-control">
                                    <option  >Select Category</option>
                                    <option>...</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <select id="formrow-inputState" className="form-control">
                                    <option  >Select Sub Category</option>
                                    <option>...</option>
                                </select>
                            </div>
                            <div className="d-flex gap-2">
                                <button className="btn btn-primary w-100">Add an Escalation</button>
                            </div>

                        </div>

                    </div>
                </div>


            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default RightAddEscalations;

